
import { Dashboard } from '../../../components/Dashboard';
import { Request } from '../../../components/Request';
import StateHelpers from '../store/StateHelpers';
import { setChatRoomAsActive } from './chat';
import { possibleTabs } from '../reducers/matchmaking';
import { LadderPopup } from '../../../components/LadderPopup';
import { Html } from '../../../components/Html';
import { Match } from '../../../models/Match';
import { MatchHistoryTableComponent } from '../../match/MatchHistoryTableComponent';
import StartupEventManager from "../../../app/StartupEventManager";

export const MATCHMAKING_OPEN = 'MATCHMAKING_OPEN';
export const MATCHMAKING_CLOSE = 'MATCHMAKING_CLOSE';

export const PREFERRED_GAMES_UPDATE = 'PREFERRED_GAMES_UPDATE';
export const MATCHMAKING_SHOW_GAMES = 'MATCHMAKING_SHOW_GAMES';


export const MATCHMAKING_LIST_ADDED_MATCH = 'MATCHMAKING_LIST_ADDED_MATCH';
export const MATCHMAKING_LIST_REMOVED_MATCH = 'MATCHMAKING_LIST_REMOVED_MATCH';
export const MATCHMAKING_LIST_SORTED_LIST = 'MATCHMAKING_LIST_SORTED_LIST';
export const MATCHMAKING_REFRESH_LOBBY_LIST_BEGIN = 'MATCHMAKING_REFRESH_LOBBY_LIST_BEGIN';
export const MATCHMAKING_REFRESH_LOBBY_LIST_FAIL = 'MATCHMAKING_REFRESH_LOBBY_LIST_FAIL';
export const MATCHMAKING_REFRESH_LOBBY_LIST_SUCCESS = 'MATCHMAKING_REFRESH_LOBBY_LIST_SUCCESS';
export const CHANGE_MATCHMAKING_TAB = 'CHANGE_MATCHMAKING_TAB';

export const CURRENT_MATCH_UPDATE = 'CURRENT_MATCH_UPDATE';

export const SET_MATCH_MANAGER = 'SET_MATCH_MANAGER';

export const RETRIEVE_CURRENT_MATCH_BEGIN = 'RETRIEVE_CURRENT_MATCH_BEGIN';
export const RETRIEVE_CURRENT_MATCH_SUCCESS = 'RETRIEVE_CURRENT_MATCH_SUCCESS';
export const RETRIEVE_CURRENT_MATCH_FAIL = 'RETRIEVE_CURRENT_MATCH_FAIL';


export const VIEW_GAME_ACTIVITY_BEGIN = 'VIEW_GAME_ACTIVITY_BEGIN';
export const VIEW_GAME_ACTIVITY_SUCCESS = 'VIEW_GAME_ACTIVITY_SUCCESS';
export const VIEW_GAME_ACTIVITY_FAIL = 'VIEW_GAME_ACTIVITY_FAIL';

export const VIEW_GAME_ACTIVITY_MATCH_LIST_BEGIN = 'VIEW_GAME_ACTIVITY_MATCH_LIST_BEGIN';
export const VIEW_GAME_ACTIVITY_MATCH_LIST_SUCCESS = 'VIEW_GAME_ACTIVITY_MATCH_LIST_SUCCESS';
export const VIEW_GAME_ACTIVITY_MATCH_LIST_FAIL = 'VIEW_GAME_ACTIVITY_MATCH_LIST_FAIL';

export const OPENED_MATCH_POPUP = 'OPENED_MATCH_POPUP';
export const CLOSED_MATCH_POPUP = 'CLOSED_MATCH_POPUP';

export const MATCHMAKING_SEARCH_MISSED = 'MATCHMAKING_SEARCH_MISSED';
export const MATCHMAKING_SEARCH_MISSED_CLEAR = 'MATCHMAKING_SEARCH_MISSED_CLEAR';

export const MATCHMAKING_HAS_CHALLENGE_WAITING = 'MATCHMAKING_HAS_CHALLENGE_WAITING';
export const REJECTED_MATCH = 'REJECTED_MATCH';

export const AUTO_QUEUE_MATCHUP_FOUND = 'AUTO_QUEUE_MATCHUP_FOUND';
export const AUTO_QUEUE_MATCHUP_EXPIRED_YOU_NO_REPLY = 'AUTO_QUEUE_MATCHUP_EXPIRED_YOU_NO_REPLY';
export const AUTO_QUEUE_MATCHUP_EXPIRED_OTHER_PLAYER_NO_REPLY = 'AUTO_QUEUE_MATCHUP_EXPIRED_OTHER_PLAYER_NO_REPLY';

export const AUTO_QUEUE_ACTIVE_STATUS_BEGIN = 'AUTO_QUEUE_ACTIVE_STATUS_BEGIN';
export const AUTO_QUEUE_ACTIVE_STATUS_SUCCESS = 'AUTO_QUEUE_ACTIVE_STATUS_SUCCESS';
export const AUTO_QUEUE_ACTIVE_STATUS_FAIL = 'AUTO_QUEUE_ACTIVE_STATUS_FAIL';

export const checkAutoQueueServerStatus = () => (dispatch, getState) => {
	const { autoQueueServerStatusIsBeingChecked, autoQueueServerIsActive } = getState().matchmaking;
	if(autoQueueServerStatusIsBeingChecked || autoQueueServerIsActive) {
		return;
	}
	dispatch({
		type: AUTO_QUEUE_ACTIVE_STATUS_BEGIN
	});
	Request.apiv1Get('server/matchmaking_server_status')
		.then(() => {
			dispatch({
				type: AUTO_QUEUE_ACTIVE_STATUS_SUCCESS
			});
		})
		.catch((error) => {
			console.error(error);
			dispatch({
				type: AUTO_QUEUE_ACTIVE_STATUS_FAIL
			});
		});
};

export const changeMatchmakingTab = (tabName) => (dispatch, getState) => {
	if(StateHelpers.mainChatIsActive()) {
		const { selectedMainChat } = getState().chat;
		if(selectedMainChat) {
			dispatch(setChatRoomAsActive(selectedMainChat));
		}
	}
	dispatch({
		type: CHANGE_MATCHMAKING_TAB,
		payload: tabName
	});
};

export const returnToMatchmakingTab = () => (dispatch) => {
	dispatch(changeMatchmakingTab(possibleTabs.matchmaking));
};

export const autoQueueMatchupFound = (matchupData) => {
	const payload = matchupData;
	if(matchupData.expiration === true) {
		if(matchupData.requeue) {
			return {
				type: AUTO_QUEUE_MATCHUP_EXPIRED_OTHER_PLAYER_NO_REPLY,
				payload
			};
		}
		else {
			return {
				type: AUTO_QUEUE_MATCHUP_EXPIRED_YOU_NO_REPLY,
				payload
			};
		}
	}
	return {
		type: AUTO_QUEUE_MATCHUP_FOUND,
		payload
	};
};

export const viewGameActivity = (preferredGameFilter) => (dispatch) => {
	if(!preferredGameFilter) {
		console.error('No data!');
		return;
	}
	dispatch({
		type: VIEW_GAME_ACTIVITY_BEGIN,
		payload: preferredGameFilter,
	});

	const ladder = preferredGameFilter.gameRoom;
	const ladderId = preferredGameFilter.id;
	// const popup = $('<div>');
	// const ladderPopup = LadderPopup.create(popup, `${Html.encode(ladder.name)} Activity`, {}).showLoader();
	Request.apiv1Get('ladders/active_players', { ladder_id: ladderId })
		.then((response) => {
			console.log('the response', response);
			dispatch({
				type: VIEW_GAME_ACTIVITY_SUCCESS,
				payload: {
					stats: {
						general: response.ladder_stats,
						mostActivePlayersToday: response.most_active_players_today,
						mostActivePlayersThisWeek: response.most_active_players_this_week,
					}
				}
			});
			return response.html;
		})
		.then((html) => {
			dispatch({
				type: VIEW_GAME_ACTIVITY_MATCH_LIST_BEGIN
			});
			Request.apiv1Get('ladders/activity', { ladder_id: ladderId })
				.then((response) => {
					const matchMap = new Map();
					_.each(response.matches, (match) => {
						match = Match.retrieve(match);
						matchMap.set(match.id, match);
					});
					dispatch({
						type: VIEW_GAME_ACTIVITY_MATCH_LIST_SUCCESS,
						payload: {
							matches: matchMap
						}
					});
				})
				.finally(() => {
					dispatch({
						type: VIEW_GAME_ACTIVITY_MATCH_LIST_FAIL
					});
				});
		})
		.catch((error) => {
			dispatch({
				type: VIEW_GAME_ACTIVITY_FAIL
			});
			// ladderPopup.updateContent(response.error);
		});
};

// A GET match/current_match response, or the startup payload's current_match section.
export const applyCurrentMatch = (response) => (dispatch) => {
	dispatch({
		type: RETRIEVE_CURRENT_MATCH_SUCCESS
	});
	if(response.match) {
		const data = {
			current_matches: {}
		};
		data.current_matches[response.match.id] = response.match;
		Dashboard.performOpenSearchUpdate(data);
	}
};

export const retrieveCurrentMatch = () => (dispatch, getState) => new Promise((resolve, reject) => {
	dispatch({
		type: RETRIEVE_CURRENT_MATCH_BEGIN
	});
	Request.apiv1Get('match/current_match')
		.then(function(response) {
			dispatch(applyCurrentMatch(response));
			resolve();
		})
		.catch((error) => {
			dispatch({
				type: RETRIEVE_CURRENT_MATCH_FAIL
			});
			reject(error);
		})
	;
});

export const openedMatchPopup = () => (dispatch, getState) => {
	dispatch({
		type: OPENED_MATCH_POPUP
	});
	dispatch(returnToMatchView());
};

export const closedMatchPopup = () => (dispatch, getState) => {
	dispatch({
		type: CLOSED_MATCH_POPUP
	});
};
export const rejectedMatch = (matchId) => {
	return {
		type: REJECTED_MATCH,
		payload: matchId,
	};
};
export const returnToMatchView = () => (dispatch, getState) => {
	dispatch({
		type: CHANGE_MATCHMAKING_TAB,
		payload: 'battle'
	});
	const { currentMatch } = getState().matchmaking;
	if(!currentMatch) {
		dispatch(retrieveCurrentMatch());
	}
};

export const currentMatchUpdate = (match) => {
	return {
		type: CURRENT_MATCH_UPDATE,
		payload: match
	};
};

export const setMatchSearchListManager = (manager) => {
	return {
		type: SET_MATCH_MANAGER,
		payload: manager
	};
};
export const displayMissedChallengeNotifications = () => (dispatch, getState) => {
	const { searchesMissed } = getState().matchmaking;
};

export const clearAllMissedSearches = () => {
	return {
		type: MATCHMAKING_SEARCH_MISSED_CLEAR
	};
};

export const matchmakingListUpdated = (name, currentListMatchList, possiblyRemovedMatches) => (dispatch, getState) => {
	const listName = `matchmakingList${name}`;
	const matchmakingState = getState().matchmaking;
	const theList = matchmakingState[listName];
	const { matchmakingHasChallenge } = matchmakingState;
	if(theList) {
		theList.forEach((matchId) => {
			if(currentListMatchList.has(matchId)) {
			}
			else {
				const matchThatWasRemoved = possiblyRemovedMatches[matchId];
				if(matchThatWasRemoved && matchThatWasRemoved.requiresResponseFromMe()) {
					dispatch({
						type: MATCHMAKING_SEARCH_MISSED,
						payload: matchThatWasRemoved,
					});
				}
			}
		});
	}

	let updatedHasChallenge = false;
	currentListMatchList.forEach((match) => {
		if(match.requiresResponseFromMe()) {
			updatedHasChallenge = true;
			return false;
		}
	});
	if(matchmakingHasChallenge !== updatedHasChallenge) {
		dispatch({
			type: MATCHMAKING_HAS_CHALLENGE_WAITING,
			payload: updatedHasChallenge,
		});
	}

	dispatch({
		type: MATCHMAKING_LIST_SORTED_LIST,
		payload: {
			name,
			list: currentListMatchList,
		}
	});
};

export const refreshMatchmakingList = () => (dispatch, getState) => {
	const { matchmakingRefreshingLobbyList } = getState().matchmaking;
	const { matchSearchListManager } = require('components/MatchSearchListManager');
	return StartupEventManager.userLoaded()
		.then(() => {
			if(matchmakingRefreshingLobbyList) {
				dispatch({
					type: MATCHMAKING_REFRESH_LOBBY_LIST_FAIL,
					payload: 'Already Refreshing'
				});
				return;
			}
			dispatch({
				type: MATCHMAKING_REFRESH_LOBBY_LIST_BEGIN
			});
			return Request.apiv1Get('matchmaking/visible_searches')
				.then((response) => {
					dispatch({
						type: MATCHMAKING_REFRESH_LOBBY_LIST_SUCCESS
					});
					matchSearchListManager.clearAll();
					Dashboard.performOpenSearchUpdate(response);
					if(matchSearchListManager.hasAutoQueueMatchCreatedByMe()) {
						Request.apiv1Get('matchmaking/auto_queue_status')
							.then((response) => {
								_.each(response.auto_queue_match_updates, (update) => {
									Dashboard.performOpenSearchUpdate({ 'auto_queue_match_update': update });
								});
							})
							.catch((error) => {
								Request.generalJsonError(error);
							});
					}
				})
				.catch((error) => {
					Request.generalJsonError(error);
					dispatch({
						type: MATCHMAKING_REFRESH_LOBBY_LIST_FAIL,
					});
				});
		});

};

export const preferredGamesUpdated = (preferredGamesList) => {
	return {
		type: PREFERRED_GAMES_UPDATE,
		payload: preferredGamesList
	};
};

export const returnToMatchmaking = () => (dispatch, getState) => {
	// dispatch(refreshMatchmakingList()); -- I think this only needs to happen when the tab remounts itself
	dispatch({
		type: MATCHMAKING_CLOSE
	});
};

export const SET_ACTIVE_SEARCH_TYPE = 'SET_ACTIVE_SEARCH_TYPE';
export const setActiveSearchType = (searchType) => ({
	type: SET_ACTIVE_SEARCH_TYPE,
	searchType,
});